import { useEffect } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import mapVideo from '../../public/assets/videos/investor-rise-bg-map.mp4';
// import { Button } from '@/components/ui/button';
import Logo  from '../../public/assets/images/logo2.png';

export default function ContactUs() {
    const [step, setStep] = useState('initial');
  const [selectedOption, setSelectedOption] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const renderForm = () => {
    const formBaseClass =
      'w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-4 focus:ring-teal-400 text-lg';

    return (
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="space-y-6"
      >
         <img
            src={Logo}
            alt="Company Logo"
            className="w-20 md:w-40 drop-shadow-xl animate-float"
          />
        <h3 className="text-3xl font-semibold text-gray-900 mb-3">
          {selectedOption === 'invest'
            ? 'Invest with InvestorRise'
            : selectedOption === 'careers'
            ? 'Join Our Careers'
            : 'General Enquiries'}
        </h3>

        {selectedOption === 'invest' && (
          <>
            <input className={formBaseClass} placeholder="Full Name" />
            <input className={formBaseClass} placeholder="Email Address" />
            <textarea className={formBaseClass} placeholder="Your Investment Goals" rows={4} />
          </>
        )}

        {selectedOption === 'careers' && (
          <>
            <input className={formBaseClass} placeholder="Full Name" />
            <input className={formBaseClass} placeholder="Email Address" />
            <input className={formBaseClass} placeholder="LinkedIn Profile" />
            <textarea className={formBaseClass} placeholder="Why do you want to join us?" rows={4} />
          </>
        )}

        {selectedOption === 'enquiries' && (
          <>
            <input className={formBaseClass} placeholder="Full Name" />
            <input className={formBaseClass} placeholder="Email Address" />
            <textarea className={formBaseClass} placeholder="Your Message" rows={4} />
          </>
        )}

        <div className="flex justify-between items-center pt-6">
          <button
            onClick={() => {
              setStep('options');
              setSelectedOption('');
            }}
            className="text-teal-600 hover:underline text-lg transition"
          >
            ← Back
          </button>
          <button className="bg-teal-600 hover:bg-slate-900 text-white px-7 py-3 shadow transition duration-300 text-lg">
            Submit
          </button>
        </div>
      </motion.div>
    );
  };

  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
    {/* Background Image with Zoom Out */}
    <motion.div
      initial={{ scale: 1.2 }}
      animate={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/Contact-hero-img.jpg')" }}
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-30" />

    {/* Heading on the Left */}
    <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0">
      <motion.h1
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold bg-black bg-opacity-40 px-4 py-3 sm:px-6 sm:py-6 rounded-xl shadow-xl max-w-[90%] sm:max-w-[70%]"
      >
        Contact Us
      </motion.h1>
    </div>
  </div>




    {/* Contact Info Section */}
<div className="relative h-[500px] md:h-[280px] overflow-hidden">
  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
  >
    <source src={mapVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Green Overlay */}
  <div className="absolute top-0 left-0 w-full h-full bg-slate-950 bg-opacity-30 z-10" />

  {/* Contact Info Content */}
  <div className="relative z-20 h-full flex items-center">
    <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-around text-white text-center gap-8 w-full">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaMapMarkerAlt size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">10394 W Sample, Road #200, Coral Springs, FL 33065</h3>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaPhoneAlt size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">+1 954 803 4967</h3>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="flex-1"
      >
        <FaEnvelope size={40} className="mx-auto mb-2" color={'#14b8a6'} />
        <h3 className="text-base md:text-lg font-semibold">info@investorrise.com</h3>
      </motion.div>
    </div>
  </div>
</div>


    


<div className="py-20 px-4 md:px-20 bg-gradient-to-b from-white via-gray-50 to-white min-h-screen font-sans overflow-x-hidden">
  {step === 'initial' && (
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16">
      {/* Left Side Logo & Heading */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="w-full md:w-1/2 flex justify-center"
      >
        <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
          <img
            src={Logo}
            alt="Company Logo"
            className="w-28 md:w-56 drop-shadow-xl animate-float"
          />
          <div className="flex text-3xl md:text-6xl font-bold tracking-tight text-gray-800">
            <motion.span
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              Investor
            </motion.span>
            <motion.span
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 1 }}
              className="text-teal-500 font-medium ml-2"
            >
              Rise
            </motion.span>
          </div>
        </div>
      </motion.div>

      {/* Right Side Enquiry Card */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 3 }}
        className="w-full md:w-1/2 bg-slate-800 p-10 rounded-3xl shadow-2xl text-center"
      >
        <h2 className="text-4xl font-bold mb-6 text-white">How can we help you?</h2>
        <p className="text-xl mb-8 text-white opacity-90 leading-relaxed">
          Submit an enquiry, explore career opportunities, or become one of the thousands of successful investors with InvestorRise.
        </p>
        <button
          onClick={() => setStep('options')}
          className="relative overflow-hidden py-4 px-10 text-white font-semibold bg-teal-500 shadow-xl text-lg group"
        >
          <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Submit an Enquiry</span>
        </button>
      </motion.div>
    </div>
  )}

  {step === 'options' && (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9 }}
      className="max-w-3xl mx-auto bg-slate-800 shadow-2xl rounded-3xl p-12 mt-12 text-center"
    >
      <h2 className="text-4xl font-bold text-white mb-10">What are you interested in?</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {['invest', 'careers', 'enquiries'].map(option => (
          <button
            key={option}
            onClick={() => setSelectedOption(option)}
            className={`p-6 rounded-xl transition border-2 text-lg font-medium duration-300 ${
              selectedOption === option
                ? 'border-white bg-slate-900 text-white'
                : 'text-gray-50 bg-teal-600 hover:bg-teal-700 hover:border-teal-400 hover:scale-105 hover:shadow-xl'
            }`}
          >
            {option === 'invest' && 'Invest with InvestorRise'}
            {option === 'careers' && 'Careers'}
            {option === 'enquiries' && 'Enquiries'}
          </button>
        ))}
      </div>
      <button
        onClick={() => selectedOption && setStep('form')}
        disabled={!selectedOption}
        className={`mt-4 px-10 py-4 text-white font-semibold transition duration-300 text-lg relative overflow-hidden group ${
          selectedOption ? 'cursor-pointer bg-teal-500' : 'bg-gray-300 cursor-not-allowed'
        }`}
      >
        {selectedOption && (
          <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 animate-slide-bg group-hover:from-slate-900 group-hover:to-slate-900 transition-all duration-500 ease-in-out" />
        )}
        <span className="relative z-10">Continue →</span>
      </button>
    </motion.div>
  )}

  {step === 'form' && (
    <div className="max-w-3xl mx-auto bg-white shadow-slate-800 shadow-2xl rounded-3xl p-12 mt-12">
      {renderForm()}
    </div>
  )}
</div>










    
      {/* Map Section */}
      <motion.div
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  className="relative w-full h-[300px] md:h-[600px] overflow-hidden"
>
  <div className="w-full h-full">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3169.0050421687094!2d-122.08560868468984!3d37.42206597982592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb24c2b85bb01%3A0x3e1af3e2a52e21bd!2sGoogleplex!5e0!3m2!1sen!2sus!4v1610000000000!5m2!1sen!2sus"
      className="w-full h-full border-0 filter grayscale contrast-125 brightness-90"
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      style={{ display: "block" }} // This ensures no inline overflow
    ></iframe>
  </div>
  <div className="absolute top-0 left-0 w-full h-full bg-slate-900 opacity-30 pointer-events-none" />
</motion.div>


    </div>
  );
}
